import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/capm-calculator',
  component: () => import('../../routes/CapmCalculator.svelte'),
  card: {
    id: 'capm-calculator',
    title: 'CAPM Calculator',
    description: 'Calculate expected asset return using the Capital Asset Pricing Model (CAPM) formula with beta, market risk premium, and risk-free rate inputs.',
    icon: 'trending_up',
    iconBgClass: 'bg-indigo-50',
    iconTextClass: 'text-indigo-600',
    href: '/capm-calculator',
    category: 'Savings & Investing',
  },
  seo: {
    title: 'CAPM Calculator – Capital Asset Pricing Model Expected Return',
    description: 'Free CAPM calculator to compute expected asset returns using beta, market risk premium, and risk-free rate. Evaluate if a stock is overvalued or undervalued relative to its systematic risk.',
  },
};

export default meta;